import React, { useMemo } from "react";

import useGetWindowWidth from "../../../../utils/useGetWindowWidth";

import { BsCheck, BsX } from "react-icons/bs";
import { CgArrowRight } from "react-icons/cg";
import styles from "./styles.module.scss";

export function CardShippingStage({ cardData, shipping, type, last, order }) {
  const widthWindows = useGetWindowWidth();

  const isMobile = widthWindows < 769;

  const handleSubStatus = (cardData, shipping) => {

    const extractUf = (desc) => {
      const splitedDesc = desc?.split(" ")
      const ufs = []
      if (splitedDesc?.length > 3) {
        ufs.push(splitedDesc[1].length ? splitedDesc[1] : splitedDesc[2]);
        ufs.push(splitedDesc[1].length ? splitedDesc[3] : splitedDesc[4]);
      }

      return ufs
    }

    if (cardData?.status === "Expedido") {
      const splitedCorreiosDescription = cardData?.correiosDescription?.split(": ")
      const fromToPathFromApi = splitedCorreiosDescription?.length > 1
        ? splitedCorreiosDescription[1]
        : undefined
      let ufs = []
      if (fromToPathFromApi) {
        ufs = extractUf(fromToPathFromApi)
      } else {
        if (shipping?.origin?.state) {
          ufs.push(shipping?.origin?.state?.toUpperCase())
        }
        if (shipping?.destination?.state) {
          ufs.push(shipping?.destination?.state?.toUpperCase())
        }
      }

      return ufs.length > 1 ? <span>{ufs[0]} → {ufs[1]}</span> : undefined
    }
  }

  const handleDescription = (cardData) => {
    if (cardData?.status === "Expedido") {
      return cardData?.description?.split("/")
    }

    return cardData?.description?.split("/") ||
      cardData.correiosDescription?.split("/");
  }

  const description = handleDescription(cardData);
  const subStatus = handleSubStatus(cardData, shipping);


  const handleStatusColor = (status = null) => {
    const color = {
      "Não foi possível entregar o objeto": "#FF6B71",
      "Objeto extraviado": "#FF6B71",
      "Objeto não foi entregue": "#FF6B71",
      "Objeto Cancelado": "#FF6B71",
      "Objeto Devolvido": "#FFAF52",
      "Objeto pronto para retirada": "#3C7DD9"
    };

    if (color[status] && last) {
      return color[status];
    }

    return last ? "#409e6a" : "#B3B3B3";
  };

  const handleErrorStatus = status => {
    const statusError = [
      "Não foi possível entregar o objeto",
      "Objeto extraviado",
      "Objeto não foi entregue",
      "Objeto Cancelado"
    ];

    return statusError.includes(status) ? true : false;
  };

  return (
    <>
      <div
        className={`${styles.cardObject} ${type === "inactive" ? styles.inactive : ""
          }`}
      >
        <div
          style={{ backgroundColor: handleStatusColor(cardData.status) }}
          className={styles.iconTimeline}
        >
          {handleErrorStatus(cardData.status) && last
            ? <BsX />
            : isMobile && cardData.icon
              ? cardData.icon
              : <BsCheck />
          }
          {isMobile && !last &&
            <>
              <div className={styles.dot}></div>
              <div className={styles.dot2}></div>
              <div className={styles.dot3}></div>
            </>
          }
        </div>
        {!last && <span className={`${styles.timeline}`}></span>}
        <div
          style={{ color: last ? "" : "#B3B3B3" }}
          className={styles.cardContent}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "10px"
            }}
          >
            <p
              style={{ color: handleStatusColor(cardData.status) }}
              className={styles.status}
            >
              {cardData.status}
            </p>
            {window.screen.width > 769 && "-"}
            <p
              style={{
                color:
                  cardData.status === "Não foi possível entregar o objeto" &&
                    last
                    ? "#FF6B71"
                    : ""
              }}
            >
              {cardData.date}
            </p>
            -
            {description.length > 1 ? (
              <div>
                <div
                  style={{
                    color:
                      cardData.status ===
                        "Não foi possível entregar o objeto" && last
                        ? "#FF6B71"
                        : ""
                  }}
                  className={styles.description}
                >
                  <p>{description[0]}</p>
                  <CgArrowRight className={styles.descriptionSvg} />
                  <p>{description[1]}</p>
                </div>
              </div>
            ) : (
              <div
                style={{
                  color:
                    cardData.status === "Não foi possível entregar o objeto" &&
                      last
                      ? "#FF6B71"
                      : ""
                }}
                className={styles.description}
              >
                <p>{description[0] || cardData.correiosDescription}</p>
              </div>
            )}
          </div>
          {cardData.status === "Outros" && (
            <div className={styles.address}>
              <span>{cardData?.correiosDescription}</span>
            </div>
          )}
          {cardData.status === "Expedido" && subStatus && (
            <div className={styles.address}>
              <span>{subStatus}</span>
            </div>
          )}
          {cardData?.address !== "" && cardData?.address !== undefined && (
            <div className={styles.address}>
              <span>Aguardando retirada em:</span>
              <br />
              <span>{cardData?.address}</span>
            </div>
          )}
          {cardData.status === "Não foi possível entregar o objeto" && (
            <div className={styles.address}>
              <span
                style={{
                  color:
                    cardData.status === "Não foi possível entregar o objeto" &&
                      last
                      ? "#FF6B71"
                      : ""
                }}
              >
                {cardData?.correiosDescription}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
